import { action, observable } from 'mobx';
import { HttpClient } from 'Mri.Web.Common';

export class DisplayConfigurationStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAsync(serialNumber: string) {
        const displayConfiguration = await this.httpClient.get<Mri.DisplayConfigurations.DisplayConfiguration>(
            `/api/v1/displays/${serialNumber}/config`
        );

        if (displayConfiguration)
            this.displayConfigurations.set(displayConfiguration.displaySerialNumber, displayConfiguration);
    }

    @action
    public async updateAsync(serialNumber: string, model: Mri.DisplayConfigurations.DisplayConfiguration) {
        const displayConfiguration = await this.httpClient.put<Mri.DisplayConfigurations.DisplayConfiguration>(
            `/api/v1/displays/${serialNumber}/config`,
            model
        );

        if (displayConfiguration)
            this.displayConfigurations.set(displayConfiguration.displaySerialNumber, displayConfiguration);
    }

    @observable
    public displayConfigurations = new Map<string, Mri.DisplayConfigurations.DisplayConfiguration>();

    private readonly httpClient: HttpClient;
}
